// @ts-ignore
import news from './components/main/news.vue'
// @ts-ignore
import afil from './components/card/afil/afil.vue'
// @ts-ignore
import certificates from './components/card/certificates/certificates.vue'
// @ts-ignore
import profile from './components/profile/profile.vue'
// @ts-ignore
import monitoring from './components/monitoring/monitoring.vue'
// @ts-ignore
import moex from './components/card/moex/moex.vue'
// @ts-ignore
import rossetiMain from './components/rosseti/main.vue'
// @ts-ignore
import roosetiFooter from './components/rosseti/footer.vue'
// @ts-ignore
import roosetiHeader from './components/rosseti/header.vue'
// @ts-ignore
import visitorCheck from './components/rosseti/visitorCheck.vue'
// @ts-ignore
import visitorFLCheckCombined from './components/rosseti/visitorFLCheckCombined/visitorFLCheckCombined.vue'
// @ts-ignore
import additionalCheck from './components/rosseti/additionalCheck.vue'
// @ts-ignore
import monitoringSetDeleteButton from './components/monitoring/monitoringSetDeleteButton.vue'
//@ts-ignore
import flCheck from './components/rosseti/flCheck.vue'
//@ts-ignore
import monitoringFl from './components/monitoring-fl/monitoring-fl.vue'
//@ts-ignore
import bankrupt from './components/card/bankrupt/bankrupt.vue'
// @ts-ignore
import supportMeasures from './components/card/shortResume/supportMeasures.vue'
// @ts-ignore
import mspType from './components/card/shortResume/mspType.vue'
// @ts-ignore
import relationsSearch from './components/global/RelationsSearch/RelationsSearch.vue'
// @ts-ignore
import Search from './components/search/search.vue'
// @ts-ignore
import unfairSupplier from './components/card/shortResume/unfairSupplier/unfairSupplier.vue'
// @ts-ignore
import ved from './components/card/ved/ved.vue'
// @ts-ignore
import inspections from './components/card/inspections/inspections.vue'
// @ts-ignore
import egrulRecords from './components/card/egrulRecords/egrulRecords.vue'
// @ts-ignore
import notes from './components/card/notes/notes.vue'
// @ts-ignore
import officialCodes from './components/card/officialCodes/officialCodes.vue'
// @ts-ignore
import branches from './components/card/branches/branches.vue'
// @ts-ignore
import executory from './components/card/executory/executory.vue'
// @ts-ignore
import issuerMessage from './components/card/shortResume/issuerMessage/issuerMessage.vue'
// @ts-ignore
import tenders from './components/card/tenders/tenders.vue'
// @ts-ignore
import blockInvoices from './components/card/blockInvoices/blockInvoices.vue'
// @ts-ignore
import businessIndex from './components/card/businessIndex/businessIndex.vue'
// @ts-ignore
import zalogLeasing from './components/card/zalogLeasing/zalogLeasing.vue'

const VueInstanceObjects = [
    {
        el: "#news__vue",
        components: { news }
    },
    {
        el: "#affilation-tile",
        components: { afil }
    },
    {
        el: "#bankrupt-message",
        components: { bankrupt }
    },
    {
        el: "#certificates-tile",
        components: { certificates }
    },
    {
        el: "#moex-tile",
        components: { moex }
    },
    {
        el: "#vue-profile",
        components: {
            profile,
            'rosseti-footer': roosetiFooter,
            'rosseti-header': roosetiHeader
        }
    },
    {
        el: "#vue-monitoring",
        components: {
            monitoring,
            'rosseti-footer': roosetiFooter,
            'rosseti-header': roosetiHeader
        }
    },
    {
        el: "#rosseti-main",
        components: {
            'rosseti-main': rossetiMain,
            'rosseti-footer': roosetiFooter,
            'rosseti-header': roosetiHeader
        }
    },
    {
        el: "#rosseti-header",
        components: { "rosseti-header": roosetiHeader }
    },
    {
        el: "#rosseti-footer",
        components: { "rosseti-footer": roosetiFooter }
    },
    {
        el: "#rosseti-visitor-check",
        components: {
            'visitor-check': visitorCheck,
            'fl-check': flCheck,
            'rosseti-footer': roosetiFooter,
            'rosseti-header': roosetiHeader
        }
	},
    {
        el: "#visitor-fl-check",
        components: {
            'visitor-fl-check': visitorFLCheckCombined,
            'rosseti-footer': roosetiFooter,
            'rosseti-header': roosetiHeader
        }
	},
	{	el: "#rosseti-fl-check",
		components:{
			'fl-check': flCheck,
			'rosseti-footer': roosetiFooter,
            'rosseti-header': roosetiHeader
		}
	},
	{	el: "#monitoring-fl",
		components:{
			'monitoring-fl': monitoringFl,
			'rosseti-footer': roosetiFooter,
            'rosseti-header': roosetiHeader
		}
	},
    {
        el: "#rosseti-additional-check",
        components: {
            'additional-check': additionalCheck,
            'rosseti-footer': roosetiFooter,
            'rosseti-header': roosetiHeader
        }
    },
    {
        el: "#monitoringSetDeleteButton",
        components: {
            "monitoring-button": monitoringSetDeleteButton
        }
    },
    {
        el: "#vue-msp",
        components: {
            "support-measures": supportMeasures,
            "msp-type": mspType
        }
    },
    {
        el: "#relations-search",
        components: {
            'rosseti-header': roosetiHeader,
            "relations-search": relationsSearch,
            'rosseti-footer': roosetiFooter,
        }
    },
    {
        el: '#podbor-search',
        components: {
            'rosseti-header': roosetiHeader,
            "search": Search,
            'rosseti-footer': roosetiFooter
        }
    },
    {
        el: "#unfair_suppliers-stop-factors",
        components: { 
            "unfair-supplier": unfairSupplier
        }
    },
    {
        el: "#ved-tile",
        components: {
            "ved": ved
        }
    },
    {
        el: "#inspections-tile",
        components: {
            "inspections": inspections
        }
    },
    {
        el: "#egrulz-tile",
        components: {
            "egrul-records": egrulRecords
        }
    },
    {
        el: "#comments-tile",
        components: {
            "notes": notes
        }
    },
    {
        el: "#official-code-tile",
        components: {
            "official-codes": officialCodes
        }
    },
    {
        el: "#branches-tile",
        components: {
            "branches": branches
        }
    },
    {
        el: "#executory-tile",
        components: {
            "executory": executory
        }
    },
    {
        el: "#short-resume-issuer-message",
        components: {
            "issuer-message": issuerMessage
        }
    },
    {
        el: "#tenders-tile",
        components: {
            "tenders": tenders
        }
    },
    {
        el: "#block-invoices-tile",
        components: {
            "block-invoices": blockInvoices
        }
    },
    {
        el: "#business-index-tile",
        components: {
            "business-index": businessIndex
        }
    },
    {
        el: "#zalog-tile",
        components: {
            "zalog-leasing": zalogLeasing
        }
    }


]

export default VueInstanceObjects